/**
 *公共路由跳转函数
 *@param {参数类型}参数名 参数说明
 * this,routeInfo
 * routeInfo:{
 *  title: item.value,
    routeUrl: item.url,
    name: item.name,//菜单的名称用于切换页面缓存状态
    isNoSaveParam: true,//是否不保存url的参数  默认是不传就是保存，要是传了true就是不保存参数
    param:{}
 * }
 */
function goPage (_this, routeInfo) {
  _this.$parent.goPage(routeInfo)
}

export { goPage } 



// WEBPACK FOOTER //
// ./src/global/modules/go.js